import { telehealthConstants } from '../_constants/telehealth.constants';

export const initialState = {
  errors: [],
  isRetrieving: true,
  isSaving: false,
  isSearching: false,
  collection: [],
  rooms: [],
  details: null,
  current: {
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    cellPhoneNumber: '',
    chartId: '',
    availableOn: '',
    telehealthDate: '',
    groupId: '',
    providerId: '',
    questionnaireId: '',
    paymentAmount: '',
    patientType: '',
    telehealthType: '',
    messages: [],
  }
}

export function telehealth(state = initialState, action) {
  if (action.type === telehealthConstants.TH_CLEAR_STATE) {
    return initialState
  }

  if (action.type === telehealthConstants.RETRIEVE_TELEHEALTH_INIT) {
    return {
      ...state,
      isRetrieving: true,
      details: null
    }
  }

  if (action.type === telehealthConstants.RETRIEVE_TELEHEALTH_SUCCESS) {
    return {
      ...state,
      isRetrieving: false,
      details: action.telehealth
    }
  }

  if (action.type === telehealthConstants.RETRIEVE_TELEHEALTH_REQUEST) {
    return {
      ...state,
      isRetrieving: true
    }
  }

  if (action.type === telehealthConstants.GETALL_TELEHEALTHS_INIT) {
    return {
      ...state,
      collection: []
    }
  }

  if (action.type === telehealthConstants.GETALL_TELEHEALTHS_REQUEST) {
    return {
      ...state,
      isSearching: true
    }
  }

  if (action.type === telehealthConstants.GETALL_TELEHEALTHS_SUCCESS) {
    return {
      ...state,
      isSearching: false,
      collection: action.collection
    }
  }

  if (action.type === telehealthConstants.SAVE_TELEHEALTH_REQUEST) {
    return {
      ...state,
      isSaving: true
    }
  }

  if (action.type === telehealthConstants.SAVE_TELEHEALTH_FAILURE) {
    return {
      ...state,
      isSaving: false,
      errors: action.errors
    }
  }

  if (action.type === telehealthConstants.SAVE_TELEHEALTH_SUCCESS) {
    return {
      ...state,
      isSaving: false,
      current: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        cellPhoneNumber: '',
        chartId: '',
        telehealthDate: '',
        groupId: '',
        providerId: '',
        questionnaireId: '',
        paymentAmount: '',
        telehealthType: '',
        messages: [],
      }
    }
  }

  if (action.type === telehealthConstants.TH_PREPEND_MSG) {
    return {
      ...state,
      current: {
        ...state.current,
        messages: [
          { ...action.message },
          ...state.current.messages
        ]
      }
    }
  }

  if (action.type === telehealthConstants.GETALL_TELEHEALTH_MSG_SUCCESS) {
    return {
      ...state,
      current: {
        ...state.current,
        messages: action.messages
      }
    }
  }

  if (action.type === telehealthConstants.ADD_TELEHEALTH_MSG) {
    return {
      ...state,
      current: {
        ...state.current,
        messages: [
          action.message,
          ...state.current.messages
        ]
      }
    }
  }

  if (action.type === telehealthConstants.SET_FIRST_NAME) {
    return {
      ...state,
      current: {
        ...state.current,
        firstName: action.firstName
      }
    }
  }

  if (action.type === telehealthConstants.SET_LAST_NAME) {
    return {
      ...state,
      current: {
        ...state.current,
        lastName: action.lastName
      }
    }
  }

  if (action.type === telehealthConstants.SET_DATE_OF_BIRTH) {
    return {
      ...state,
      current: {
        ...state.current,
        dateOfBirth: action.dateOfBirth
      }
    }
  }

  if (action.type === telehealthConstants.SET_CELL_PHONE_NUMBER) {
    return {
      ...state,
      current: {
        ...state.current,
        cellPhoneNumber: action.cellPhoneNumber
      }
    }
  }

  if (action.type === telehealthConstants.SET_CHART_ID) {
    return {
      ...state,
      current: {
        ...state.current,
        chartId: action.chartId
      }
    }
  }

  if (action.type === telehealthConstants.SET_AVAILABLE_ON) {
    return {
      ...state,
      current: {
        ...state.current,
        availableOn: action.date
      }
    }
  }

  if (action.type === telehealthConstants.SET_TELEHEALTH_DATE) {
    return {
      ...state,
      current: {
        ...state.current,
        telehealthDate: action.telehealthDate
      }
    }
  }

  if (action.type === telehealthConstants.SET_GROUP_ID) {
    return {
      ...state,
      current: {
        ...state.current,
        groupId: action.id
      }
    }
  }

  if (action.type === telehealthConstants.SET_PROVIDER_ID) {
    return {
      ...state,
      current: {
        ...state.current,
        providerId: action.id
      }
    }
  }

  if (action.type === telehealthConstants.SET_QUESTIONNAIRE_ID) {
    return {
      ...state,
      current: {
        ...state.current,
        questionnaireId: action.id
      }
    }
  }

  if (action.type === telehealthConstants.SET_PAYMENT_AMOUNT) {
    return {
      ...state,
      current: {
        ...state.current,
        paymentAmount: action.amount
      }
    }
  }

  if (action.type === telehealthConstants.SET_PATIENT_TYPE) {
    return {
      ...state,
      current: {
        ...state.current,
        patientType: action.patientType
      }
    }
  }


  if (action.type === telehealthConstants.SET_TELEHEALTH_TYPE) {
    return {
      ...state,
      current: {
        ...state.current,
        telehealthType: action.telehealthType
      }
    }
  }

  if (action.type === telehealthConstants.SET_TELEMEDICINE_TYPE) {
    return {
      ...state,
      current: {
        ...state.current,
        telehealthType: action.telehealthType
      }
    }
  }

  if (action.type === telehealthConstants.TH_ROOMS_SUCCESS) {
    return {
      ...state,
      rooms: action.rooms
    }
  }

  return state;
}